import { apiGet } from '@/store/api';
import { useAttendanceStore } from '@/store/attendanceStore';

export async function getBerthedPortcalls() {
  const data = await apiGet('attendance/portcalls/');
  useAttendanceStore().setBerthedPortcalls(data);
  return data;
}
